import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    generalContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    searchContainer: {
      width: '100%',
    },
    searchField: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '6px',
        backgroundColor: '#ffffff',
        '& .MuiOutlinedInput-input': {
          fontSize: '14px',
          fontWeight: 600,
          color: '#001D29',
          '&::placeholder': {
            opacity: 1,
            color: '#001D29',
          },
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#E0E0E0',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#E0E0E0',
          borderWidth: '1px',
        },
      },
    },
    searchIcon: {
      color: '#001D29',
      fontSize: '20px',
      cursor: 'pointer',
    },
  }),
)
